import { Icon } from "@chakra-ui/react";
import { useId } from "react";

import { LinearCleanupIssueDetails } from "@reflag/shared/featureAPI";

export function LinearIssueStatusIcon({
  state,
}: {
  state: LinearCleanupIssueDetails["state"];
}) {
  const cutoutId = useId();
  // Linear's standard Duplicate state belongs to the canceled category.
  const type =
    state?.type === "canceled" &&
    state.name.trim().toLowerCase() === "duplicate"
      ? "duplicate"
      : state?.type;
  const cutouts: Record<string, string> = {
    completed: "M4.8 8.1 7 10.3 11.3 5.9",
    canceled: "M5.5 5.5 10.5 10.5 M10.5 5.5 5.5 10.5",
    duplicate: "M5 8 8 5 M8 11 11 8",
    triage:
      "M3.7 8H12.3 M3.7 8 5.8 5.9 M3.7 8 5.8 10.1 M12.3 8 10.2 5.9 M12.3 8 10.2 10.1",
  };
  const cutout = cutouts[type ?? ""];

  return (
    <Icon
      viewBox="0 0 16 16"
      boxSize="16px"
      flexShrink={0}
      color={state?.color || "gray.400"}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {cutout ? (
        <>
          <defs>
            <mask
              id={cutoutId}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="16"
              height="16"
            >
              <rect width="16" height="16" fill="white" />
              <path
                d={cutout}
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </mask>
          </defs>
          <circle
            cx="8"
            cy="8"
            r="7"
            fill="currentColor"
            mask={`url(#${cutoutId})`}
          />
        </>
      ) : (
        <>
          <circle
            cx="8"
            cy="8"
            r="6.1"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeDasharray={type === "backlog" ? "1.4 1.6" : undefined}
          />
          {type === "started" && (
            <path d="M8 4.2A3.8 3.8 0 0 1 11.8 8H8Z" fill="currentColor" />
          )}
        </>
      )}
    </Icon>
  );
}
